
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { AppConfig } from './../../../app.config';
import { Autorization } from './../../../services/shared.define';
import * as moment from 'moment';
import { ConditionalExpr } from '@angular/compiler';

@Injectable()
export class DeclarationsService {

    private urlGetDelcarationInfos: string = '';
    private urlValidateDeclaration: string = '';
    private urlChangeDeclarationTonInProgress: string = '';
    private urlControlerDeclaration: string = '';
    private urlControlerConformeDeclaration: string = '';

    public DeclarationStatus__EnAttente: number = 0;
    private DeclarationStatus__EnCours: number = 1;
    private DeclarationStatus__ValidationUTOM: number = 2;
    private DeclarationStatus__EnCoursControle: number = 3;
    private DeclarationStatus__ValidationCiteo: number = 5;
    private DeclarationStatus__EnAttenteInfosUTOM: number = 6;
    public DeclarationStatus__invalideCiteo: number = 8;
    public DeclarationStatus__InvalideUTOM: number = 9;

    constructor(private http: HttpClient, private _appConfig: AppConfig) {
        this.urlGetDelcarationInfos = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetDeclarationById?idDett=';
        this.urlValidateDeclaration = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/UpdateStatus?idStatus=' + this.DeclarationStatus__ValidationUTOM + '&idDett=';
        this.urlChangeDeclarationTonInProgress = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/UpdateStatus?idStatus=' + this.DeclarationStatus__EnCours + '&idDett=';
        this.urlControlerDeclaration = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/UpdateStatus?idStatus=' + this.DeclarationStatus__EnCoursControle + '&idDett=';
        this.urlControlerConformeDeclaration = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/UpdateStatus?idStatus=' + this.DeclarationStatus__ValidationCiteo + '&idDett=';
    }

    urlInvalidateDeclaration(idDett) {
        const autorization: Autorization = this.getAutorization();
        let result: string = '';
        if (autorization.InvaliderCiteo ) {
            result =  this._appConfig.getConfig().nPointDeclarations + '/decla-traitement/UpdateStatus?idStatus=' + this.DeclarationStatus__invalideCiteo + '&idDett=' + idDett;
        } else if (autorization.InvaliderCl) {
            result =  this._appConfig.getConfig().nPointDeclarations + '/decla-traitement/UpdateStatus?idStatus=' + this.DeclarationStatus__InvalideUTOM + '&idDett=' + idDett;
        }
        return result;
    }

    getDelcarationInfos(idDett): Observable<any> {
        return this.http.get(this.urlGetDelcarationInfos + idDett)
            .catch(this.handleError);
    }

    private getAutorization() {
            return (JSON.parse(sessionStorage.getItem('utom-infos')) || {}).autorisation || {};
    }

    invalidateDeclaration(idDett): Observable<any> {
        return this.http.post(this.urlInvalidateDeclaration(idDett), {})
            .catch(this.handleError);
    }
    validateDeclaration(idDett): Observable<any> {
        return this.http.post(this.urlValidateDeclaration + idDett, {})
            .catch(this.handleError);
    }

    changeDeclarationTonInProgress(idDett): Observable<any> {
        return this.http.post(this.urlChangeDeclarationTonInProgress + idDett, {})
            .catch(this.handleError);
    }

    controlerConformeDeclaration(idDett) {
        return this.http.post(this.urlControlerConformeDeclaration + idDett, {})
            .catch(this.handleError);

    }
    controlerDeclaration(idDett) {
        return this.http.post(this.urlControlerDeclaration + idDett, {})
            .catch(this.handleError);
    }

    isConsultaionMode(status, date) {
        const UtomInfo = JSON.parse(sessionStorage.getItem('utom-infos')) || {};
        const autorisation: Autorization = (UtomInfo.autorisation || {});
        let modifiableDeclaration = (((status == this.DeclarationStatus__EnAttente) || (status == this.DeclarationStatus__EnCours) || (status == this.DeclarationStatus__EnAttenteInfosUTOM) || (status == this.DeclarationStatus__InvalideUTOM) || (status == this.DeclarationStatus__invalideCiteo)));
        modifiableDeclaration = modifiableDeclaration && autorisation.Enregistrer && (autorisation.ModifApresDate || moment().isBefore(moment(date), 'day'));
        return !modifiableDeclaration;
    }

    getDeclarationAutorisation(): Autorization {
        const UtomInfo = JSON.parse(sessionStorage.getItem('utom-infos'));
        return (UtomInfo.autorisation || {});
    }

    displayValidateButton(status) { // this.getDeclarationAutorisation().ValiderCiteo pour ControlerConforme
        return ((this.getDeclarationAutorisation().ValiderCl) && (status == this.DeclarationStatus__EnCours));
    }
  displayInvalidateButton(status, dateLimite) {
    if (dateLimite) {
      if (!this.getDeclarationAutorisation().ModifApresDate && moment().isAfter(moment(dateLimite, "YYYY-MM-DD"), 'day')) {
        return false;
      }
    }

    return (this.getDeclarationAutorisation().InvaliderCl && (status == this.DeclarationStatus__ValidationUTOM)) ||
      (this.getDeclarationAutorisation().InvaliderCiteo &&
        ((status == this.DeclarationStatus__ValidationUTOM)
          || (status == this.DeclarationStatus__EnCoursControle)
          || (status == this.DeclarationStatus__ValidationCiteo)
        )
      );
  }

    displayControlerConformeButton(status, dateLimite) {
        if (dateLimite) {
            if (!this.getDeclarationAutorisation().ModifApresDate && moment().isAfter(moment(dateLimite, "YYYY-MM-DD"), 'day')) {
                return false;
            }
        }
        return (this.getDeclarationAutorisation().ValiderCiteo && (status == this.DeclarationStatus__EnCoursControle));
    }

    displayControlerButton(status, dateLimite) {
        if (dateLimite) {
            if (!this.getDeclarationAutorisation().ModifApresDate && moment().isAfter(moment(dateLimite, "YYYY-MM-DD"), 'day')) {
                return false;
            }
        }
        return (this.getDeclarationAutorisation().Controler && (status == this.DeclarationStatus__ValidationUTOM));
    }

    isInProgress(status) {
        return (status == this.DeclarationStatus__EnCours);
    }

    private handleError(err: HttpErrorResponse) {
        let errMsg: string;
        if (err && (err.error instanceof Error)) {
            errMsg = `${err.status} - ${err.statusText || ''} ${err}`;
        } else if (err && err.error) {
            errMsg = (err.error.message ? err.error.message : err.error.toString());
        } else if (typeof err == 'string') {
            errMsg = err;
        }

        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/in/mes-declarations/services/declarations.service.ts